import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core';
import esgResources from '../../images/esgResources.jpg';
import { COLOR_CORAL, COLOR_RED_VISITED } from '../../utils/constants';

const useStyles = makeStyles({
  container: {
    justifyContent: 'space-between',
    marginTop: 80,
    marginBottom: 40,
    '@media (max-width:600px)': {
      flexDirection: 'column-reverse',
      marginTop: 40,
      marginBottom: 0,
    },
  },
  imageGrid: {
    padding: '0px 0px 0px 100px',
    // alignSelf: 'flex-end',
    '@media (max-width:900px)': {
      padding: '0px 0px 40px 50px',
    },
    '@media (max-width:600px)': {
      padding: '0px 0px 20px 0px',
    },
  },
  textGrid: {
    padding: '0px 0px 0px 160px',
    maxWidth: 720,
    '@media (max-width:1024px)': {
      padding: '20px 0px 40px 100px',
    },
    '@media (max-width:900px)': {
      padding: '20px 0px 40px 50px',
    },
    '@media (max-width:600px)': {
      padding: '20px 20px 20px 20px',
    },
  },
  link: {
    paddingBottom: '8px',
    margin: '0 0 8px',
    display: 'block',
    color: COLOR_CORAL,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
      textDecorationColor: COLOR_CORAL,
    },
    '&:visited': {
      color: COLOR_RED_VISITED,
    },
  },
});
const SustainabilityPage = () => {
  const classes = useStyles();
  return (
    <Grid container className={classes.container}>
      <Grid item sm={6} className={classes.textGrid}>
        <h3 style={{ marginTop: 0, marginBottom: '32px' }}>ESG Resources</h3>
        <Grid container>
          <Grid item xs={12}>
            <a
              href="https://firebasestorage.googleapis.com/v0/b/vow-asa.appspot.com/o/sustainability%2FSustainability%20Report%202020%20for%20print.pdf?alt=media&token=68a2f525-264a-4fc3-aea1-0926acd4d633"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              Sustainability Report 2020 for print - PDF
            </a>
          </Grid>
          <Grid item xs={12}>
            <a
              href="https://firebasestorage.googleapis.com/v0/b/vow-asa.appspot.com/o/sustainability%2FSustainability%20Report%202020%20for%20web.pdf?alt=media&token=68399604-a031-4c56-818f-4c1d028fa0db"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              Sustainability Report 2020 for web - PDF
            </a>
          </Grid>
          <Grid item xs={12}>
            <a
              href="https://firebasestorage.googleapis.com/v0/b/vow-asa.appspot.com/o/sustainability%2FGRI%20Index%202020.pdf?alt=media&token=a98b8503-16e6-40c3-b7a1-ad152013510b"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              GRI Index 2020 - PDF
            </a>
          </Grid>
          <Grid item xs={12}>
            <a
              href="https://firebasestorage.googleapis.com/v0/b/vow-asa.appspot.com/o/sustainability%2FISO%209000%20certification.pdf?alt=media&token=33a96618-e793-4dd6-8ed1-2cd246802647"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              ISO 9000 certification - PDF
            </a>
          </Grid>
          <Grid item xs={12}>
            <a
              href="https://firebasestorage.googleapis.com/v0/b/vow-asa.appspot.com/o/sustainability%2FGreen%20Loan%20Statements.pdf?alt=media&token=51338381-7d7a-47cc-9bff-132231ca7e60"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              Green Loan Statements - PDF
            </a>
          </Grid>
          <Grid item xs={12}>
            <a
              href="https://firebasestorage.googleapis.com/v0/b/vow-asa.appspot.com/o/sustainability%2FVow%20Code%20of%20Conduct%20.pdf?alt=media&token=16ca23d6-55dd-4497-87a5-ccda0a7292b0"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              Vow Code of Conduct - PDF
            </a>

            <h4
              style={{
                fontSize: '1,2em',
                fontWeight: 'bold',
                paddingTop: '16px',
                paddingBottom: '16px',
              }}
            >
              For more information, please contact
            </h4>
            <p>
              Maria Kringlen Halvorsen – Sustainability Manager
              <br />
              Tel: +47 938 42 689
              <br />
              maria.halvorsen@scanship.no
            </p>
            <p>
              Erik Magelssen – CFO
              <br />
              Tel: +47 928 88 728
              <br />
              erik.magelssen@vowasa.com
            </p>
          </Grid>
        </Grid>
      </Grid>
      <Grid item sm={6} className={classes.imageGrid}>
        <img src={esgResources} alt="vow sustainability" />
      </Grid>
    </Grid>
  );
};

export default SustainabilityPage;
